<template>
  <div>
    <navbar class="navbar" />
    <v-card>
      <v-card-text>
        <v-row><v-col><h3>รายงานสินค้า</h3></v-col></v-row>
        <v-row><v-divider></v-divider></v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="itemsTableData"
              item-key="_id"
            >
              <template v-slot:item.cost="{item}">
                {{ formatCurrency(item.cost) }} บาท
              </template>
              <template v-slot:item.price="{item}">
                {{ formatCurrency(item.price) }} บาท
              </template>
              <template v-slot:item.qty="{item}">
                {{ numberWithComma(item.qty) }} ชิ้น
              </template>
              <template v-slot:item.action="{item}">
                  <v-chip
                    color="green"
                    text-color="white"
                    small
                    v-if="item.qty > item.minimumInventory"
                  >
                    สินค้าพร้อมขาย
                  </v-chip>
                  <v-chip
                    color="orange"
                    text-color="white"
                    small
                    v-if="item.qty < item.minimumInventory"
                  >
                    สินค้าใกล้หมด
                  </v-chip>
                  <v-chip
                    color="red"
                    text-color="white"
                    small
                    v-if="item.qty <= 0"
                  >
                    สินค้าหมด
                  </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import script from '@/views/pages/reports/products/product-out-of-stock/index.script';

export default script;
</script>
